// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__FHsbR","chatWrapper":"style_chatWrapper__-NXga","chatFrame":"style_chatFrame__-Hz4D"};